import { Link as WaspRouterLink, routes } from 'wasp/client/router';
import { Button } from '../../components/ui/button';
import AppLogo from '../../client/static/App.png';

export default function LandingNav() {
  return (
    <nav className='fixed top-0 left-0 right-0 z-50 bg-background/80 backdrop-blur-md border-b border-border/50'>
      <div className='mx-auto max-w-7xl px-6 lg:px-8'>
        <div className='flex h-16 items-center justify-between'>
          {/* Logo */}
          <WaspRouterLink to={routes.LandingPageRoute.to} className='flex items-center'>
            <img src={AppLogo} alt='App' className='h-10 w-auto' />
          </WaspRouterLink>

          {/* Auth buttons */}
          <div className='flex items-center gap-3'>
            <Button variant='ghost' size='sm' asChild>
              <WaspRouterLink to={routes.LoginRoute.to}>
                Log in
              </WaspRouterLink>
            </Button>
            <Button size='sm' className='rounded-full' asChild>
              <WaspRouterLink to={routes.SignupRoute.to}>
                Sign up
              </WaspRouterLink>
            </Button>
          </div>
        </div>
      </div>
    </nav>
  );
}



